import {
  Flex,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  ModalProvider,
  FilterProvider,
  Box,
  Spinner,
  MultiFileUploadProvider,
  NotFoundPage,
  PageViewProvider,
  DropdownOptions,
  TooltipPopup,
} from 'dash-ui';
import { DEFAULT_SLIDESHOW_FOLDER_NAME } from 'dash-common';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetMediaFolderByIdQuery } from 'gql/generated.graphql';

import Header from 'flow-components/Header/Header';
import Container from 'flow-components/Container/Container';
import { RoutesPath } from 'flow-components/routes/routes';

import MediaFolderDetails from 'pages/properties/PropertyMediaFolderPage/components/MediaFolderDetails/MediaFolderDetails';
import SetFolderNameModal from 'containers/properties/PropertyMedia/components/SetFolderNameModal/SetFolderNameModal';
import RemoveFolderModal from 'containers/properties/PropertyMedia/components/RemoveFolderModal/RemoveFolderModal';
import MediaPageHeader from 'containers/properties/PropertyMedia/components/MediaPageHeader/MediaPageHeader';
import RemoveMediaFileModal from 'containers/properties/PropertyMedia/components/RemoveMediaFileModal/RemoveMediaFileModal';
import MoveFileToFolderModal from 'containers/properties/PropertyMedia/components/MoveFileToFolderModal/MoveFileToFolderModal';
import EditMediaFileModal from 'containers/properties/PropertyMedia/components/EditMediaFileModal/EditMediaFileModal';
import MediaFilesView from 'containers/properties/PropertyMedia/components/MediaFilesView/MediaFilesView';

function PropertyMediaFolderPage() {
  const { id, folderId } = useParams();
  const navigate = useNavigate();

  const { data, loading } = useGetMediaFolderByIdQuery({
    variables: { folderId },
    fetchPolicy: 'network-only',
  });
  const folder = data?.getMediaFolderById;

  if (loading === false && (!folder || !id)) {
    return (
      <Box h="100%">
        <NotFoundPage onRedirect={() => navigate(RoutesPath.Home)} />
      </Box>
    );
  }

  return (
    <Box h="100%">
      <DropdownOptions />
      <TooltipPopup />
      <Header />
      <Container stickyBreadcrumbs>
        <Flex flexDirection="column" flex={1} w="100%">
          {loading && <Spinner size={32} fullContent />}
          {folder && id && (
            <Box w="100%" pos="relative">
              <PaginationProvider>
                <SearchProvider>
                  <FilterProvider>
                    <PageViewProvider>
                      <SortProvider>
                        <ModalProvider>
                          <MultiFileUploadProvider>
                            <MediaFolderDetails folder={folder} disabled />
                            <MediaPageHeader
                              propertyId={id}
                              folderId={folderId}
                              disabled
                            />
                            <MediaFilesView
                              propertyId={id}
                              folderId={folderId}
                              isSlideshowFolder={
                                folder.folderName ===
                                DEFAULT_SLIDESHOW_FOLDER_NAME
                              }
                            />
                            <SetFolderNameModal
                              propertyId={id}
                              folderId={folderId}
                            />
                            <RemoveFolderModal />
                            <RemoveMediaFileModal />
                            <EditMediaFileModal />
                            <MoveFileToFolderModal />
                          </MultiFileUploadProvider>
                        </ModalProvider>
                      </SortProvider>
                    </PageViewProvider>
                  </FilterProvider>
                </SearchProvider>
              </PaginationProvider>
            </Box>
          )}
        </Flex>
      </Container>
    </Box>
  );
}

export default PropertyMediaFolderPage;
